// Import model
import { FilterCatalogItemRequest } from '../models/FilterCatalogItemRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CatalogItemCondition } from '../models/CatalogItemCondition';
import { CatalogItemFields } from '../models/CatalogItemFields';
import { CatalogItemIndexedFields } from '../models/CatalogItemIndexedFields';

// Import dependency serializers (for complex types)
import { CatalogItemConditionSerializer } from './CatalogItemConditionSerializer';
import { CatalogItemFieldsSerializer } from './CatalogItemFieldsSerializer';
import { CatalogItemIndexedFieldsSerializer } from './CatalogItemIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterCatalogItemRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterCatalogItemRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterCatalogItemRequest instance
   */
  static deserialize(json: string): FilterCatalogItemRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterCatalogItemRequest instance
   */
  static fromObject(obj: any): FilterCatalogItemRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterCatalogItemRequest');
    }


    const instance: FilterCatalogItemRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as CatalogItemIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as CatalogItemFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        CatalogItemConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterCatalogItemRequest instances
   */
  static deserializeArray(json: string): FilterCatalogItemRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterCatalogItemRequest instance to a JSON string
   */
  static serialize(instance: FilterCatalogItemRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterCatalogItemRequest instance to a plain object
   */
  static toObject(instance: FilterCatalogItemRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        CatalogItemConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterCatalogItemRequest instances to a JSON string
   */
  static serializeArray(instances: FilterCatalogItemRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
